import moment from "moment";
import cx from "classnames";
import ImageGallery from "react-image-gallery";
import Sphere from "../../icons/sphere.svg";
import Location from "../../icons/location.svg";
import Icon from "../Icon/Icon";
import getDecodeDescription from "../../services/decodeText";
import PropTypes from "prop-types";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "../Company/Company.module.scss";
import stylesHotSpot from "./HotSpot.module.scss";

const HotSpot = ({ spot }) => {
  const imagesToGallery = spot?.photos?.map((photo) => {
    return {
      original: `${photo?.url}`,
      thumbnail: `${photo?.url}`,
      originalAlt: `${photo?.alt}`,
    };
  });

  const renderLabels = (labels, title) => {
    return (
      <>
        <h2 className={styles.infoBlock}>
          <span className={styles.companyInfoTitle}>{title}</span>
        </h2>
        <ul>
          {labels &&
            labels.map((label, index) => (
              <li className={styles.searchResultField} key={`${label}${index}`}>
                <span className={styles.field}>{label}</span>
              </li>
            ))}
        </ul>
      </>
    );
  };
  return (
    <div className={cx(styles.company, stylesHotSpot.container)}>
      {spot?.photos && (
        <ImageGallery items={imagesToGallery} originalHeight={"200"} />
      )}
      <h5 className={styles.companyType}>{spot.type}</h5>
      <h4 className={styles.companyName}>{spot && spot.name}</h4>
      <div className={styles.infoBlock}>
        <h2 className={styles.companyInfoTitle}>Countries</h2>
        <h2 className={styles.companyInfo}>
          {spot &&
            typeof spot?.countries === "object" &&
            spot?.countries?.join(", ")}
        </h2>
      </div>

      {/* Problems */}
      {spot?.problem && (
        <span className={styles.infoBlock}>
          <h2 className={styles.companyInfoTitle}>Problems</h2>
          {spot.problem.map((problem, index) => (
            <div key={index}>
              <h2 className={styles.companyInfo}>{problem?.title}</h2>
              <span className={stylesHotSpot.decodedText}>
                {getDecodeDescription(problem?.text)}
              </span>
            </div>
          ))}
        </span>
      )}
      {/* Solutions */}
      {spot?.solutions && (
        <span className={styles.infoBlock}>
          <h2 className={styles.companyInfoTitle}>Solutions</h2>
          {spot.solutions.map((solution, index) => (
            <div key={index}>
              <h2 className={styles.companyInfo}>{solution?.name}</h2>
              <h2 className={styles.companyInfo}>{solution?.author}</h2>
              <h2 className={styles.companyInfo}>{solution?.link}</h2>
              <span className={stylesHotSpot.decodedText}>
                {getDecodeDescription(solution?.text)}
              </span>
            </div>
          ))}
        </span>
      )}

      {/* Timelines */}
      {spot?.timeline && (
        <span className={styles.infoBlock}>
          <h2 className={styles.companyInfoTitle}>Timelines</h2>
          {spot.timeline.map((timeline, index) => (
            <div key={index}>
              <h2 className={styles.companyInfo}>
                {timeline?.fulldate || timeline?.date}
              </h2>
              <span
                className={stylesHotSpot.decodedText}
                dangerouslySetInnerHTML={{
                  __html: getDecodeDescription(timeline?.text),
                }}
              />
            </div>
          ))}
        </span>
      )}

      {/* FAQ */}
      {Array.isArray(spot?.faq) && spot.faq.length > 0 && (
        <span className={styles.infoBlock}>
          <h2 className={styles.companyInfoTitle}>FAQ</h2>
          {spot.faq
            .filter((item) => item?.question || item?.answer)
            .map((item, index) => (
              <div key={index}>
                <h2 className={styles.companyInfo}>{item?.question}</h2>
                <span
                  className={stylesHotSpot.decodedText}
                  dangerouslySetInnerHTML={{
                    __html: getDecodeDescription(item?.answer || ""),
                  }}
                />
              </div>
            ))}
        </span>
      )}

      {/* Fields */}
      {spot?.fields && renderLabels(spot.fields, "Fields")}
      <p className={styles.infoBlock}>
        <Icon name={Location} className={styles.organizationInfoIcon} />
        <span className={styles.spotInfo}>{spot.address}</span>
      </p>

      {/* Videos */}
      {spot?.videos && (
        <>
          <h2 className={styles.companyInfoTitle}>Videos:</h2>
          {spot.videos.map((video, index) => (
            <div key={index}>
              <a
                className={cx(styles.infoBlock, "d-inline-block")}
                href={video.url}
                target="blank"
              >
                {video.url}
              </a>
              <p>{video.title}</p>
            </div>
          ))}
        </>
      )}

      {/* Links */}
      {spot?.links && (
        <>
          <h2 className={styles.companyInfoTitle}>References:</h2>
          {spot.links.map((link, index) => (
            <div key={index}>
              <Icon name={Sphere} className={styles.organizationInfoIcon} />
              <a
                className={cx(styles.infoBlock, "d-inline-block")}
                href={link.url}
                target="blank"
              >
                {link.name}
              </a>
            </div>
          ))}
        </>
      )}

      {/* Related Organizations */}
      {spot?.relatedOrganizations && (
        <>
          <h2 className={styles.companyInfoTitle}>Related organizations:</h2>
          {spot.relatedOrganizations.map((organization, index) => (
            <div key={index}>
              <>
                <Icon name={Sphere} className={styles.organizationInfoIcon} />
                <a
                  className={cx(styles.infoBlock, "d-inline-block")}
                  href={organization.url}
                  target="blank"
                >
                  {organization.name}
                </a>
              </>
            </div>
          ))}
        </>
      )}
      {spot?.email && <p className={styles.infoBlock}> Email: {spot?.email}</p>}
      {spot?.titleSeo && (
        <p className={styles.infoBlock}> SEO Title: {spot?.titleSeo}</p>
      )}
      {spot?.descriptionSeo && (
        <p className={styles.infoBlock}>
          {" "}
          SEO Description: {spot?.descriptionSeo}
        </p>
      )}

      <p className={styles.infoBlock}>
        {moment(spot.date).format("DD/MM/YYYY")}
      </p>
      <p className={styles.infoBlock}> Author: {spot?.author}</p>
      <p className={styles.infoBlock}> Comment: {spot?.comment}</p>
    </div>
  );
};

HotSpot.propTypes = {
  spot: PropTypes.object,
};

export default HotSpot;
